import { render, staticRenderFns } from "./packOrderDetails.vue?vue&type=template&id=7f05f2c6&scoped=true"
import script from "./packOrderDetails.vue?vue&type=script&lang=js"
export * from "./packOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./packOrderDetails.vue?vue&type=style&index=0&id=7f05f2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f05f2c6",
  null
  
)

export default component.exports